import factory from './icon';
import Svg from './glyphs/ic_add_24px.svg';

export default factory(Svg);
